<div class="offcanvas-header">
	<h3 class="offcanvas-title">Add New Inventory Item</h3>
	<button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<hr class="mx-3" />
<div class="offcanvas-body">
	<div class="body">
		<div class="form-container">
			<app-standard-control type="text" name="name" [formGroup]="form" label="Name" placeholder="Name"></app-standard-control>

			<app-standard-control type="text" name="sku" [formGroup]="form" label="SKU" placeholder="SKU"></app-standard-control>

			<app-dropdown-control
				[formGroup]="form"
				[options]="categories"
				[searchable]="true"
				[clearable]="true"
				label="Category"
				name="category"
				placeholder="Select a category"
			></app-dropdown-control>
			<ng-container *ngIf="categories.length < 1">
				<div class="text-muted fst-italic">
					No categories available. Please create a category first.
					<button class="btn btn-sm btn-link" (click)="navigateToCreateCategory()">Create Category</button>
				</div>
			</ng-container>

			<app-standard-control
				type="number"
				name="costPrice"
				[formGroup]="form"
				label="Cost Price"
				placeholder="Cost Price"
			></app-standard-control>

			<app-standard-control
				type="number"
				name="sellPrice"
				[formGroup]="form"
				label="Sell Price"
				placeholder="Sell Price"
			></app-standard-control>

			<app-textarea-control
				[resizable]="true"
				[heightPx]="200"
				name="description"
				[formGroup]="form"
				label="Description"
				placeholder="Description"
			></app-textarea-control>
		</div>
	</div>

	<div class="footer">
		<div class="actions">
			<div class="buttons">
				<button
					type="button"
					class="btn btn-sm btn-primary"
					(click)="submit()"
					[disabled]="form.invalid || form.pristine || isSubmitting"
				>
					<ng-container *ngIf="isSubmitting; else notLoading">
						<div class="spinner-border spinner-border-sm" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
					</ng-container>
					<ng-template #notLoading> Create Item </ng-template>
				</button>
			</div>
		</div>
	</div>
</div>
